import { useState } from 'react';
import { PageShell } from '@noor/ui';
import {
  MODERATION_ENTITY_TYPES,
  type ChangeRequest,
  type ModerationListSearch,
} from '@/entities/moderation';
import { ModerationTable } from '@/widgets/moderation-table';
import { ModerationDetailModal } from '../ui/moderation-detail-modal';
import { ModerationFilters, ModerationQueueHeader } from '../ui/moderation-filters';

interface CategoriesModerationPageProps {
  /** Resolved list params from the route's validated search schema. */
  params: ModerationListSearch;
  /** Patch the URL search params (the source of truth for queue state). */
  onParamsChange: (next: Partial<ModerationListSearch>) => void;
}

/**
 * Categories moderation queue. Deliberately standalone — every queue owns
 * its composition and shares only the building-block components.
 */
export function CategoriesModerationPage({
  params,
  onParamsChange,
}: CategoriesModerationPageProps) {
  const [selected, setSelected] = useState<ChangeRequest | null>(null);

  return (
    <PageShell variant="fill" className="gap-5 p-0 lg:p-0">
      <div className="shrink-0">
        <ModerationQueueHeader
          params={params}
          onParamsChange={onParamsChange}
          titleKey={MODERATION_ENTITY_TYPES.categories.title}
          toolbar={<ModerationFilters params={params} onParamsChange={onParamsChange} />}
        />
      </div>
      <ModerationTable
        entityType="categories"
        params={params}
        onParamsChange={onParamsChange}
        onSelect={setSelected}
      />
      <ModerationDetailModal
        entityType="categories"
        request={selected}
        onClose={() => setSelected(null)}
      />
    </PageShell>
  );
}
